export class FBOBusinessEntity {
    id:number;
    businessEntityName: string;
    businessEntityId: string;
    incomeTaxID: string;
    businessEntityIdType: number;
    addressLine1: string;
    addressLine2: string;
    city: string;
    stateCodeId: number;
    countryCodeId: Number;
    postalCode: string;
    status: number;
    startDate: string;
    endDate: string;
    vatPayer: string;
    isInvalidStatusUpdate :boolean = false;
    row
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/fbo-business-entity.ts